module.exports = __webpack_public_path__ + "img/services-placeholder.88d7e183.jpg";